export default "__VITE_ASSET__DKYC48Gg__"